import { ImageFragment } from '@/graphql/fragments/image';
import { gql } from '@apollo/client';

export const WILDCARD_ADMIN_PAGE_QUERY = gql`
  query GetWildcardAdminPage {
    wildcardAdminPage {
      data {
        attributes {
          title
          subHeader
          listTitle
          listDescription

          form {
            schoolsTitle
            schoolsDescription
            datesTitle
            datesDescription
            logoTitle
            logoDescription
            logoSelected
            logoUploadPrompt
            logoUploadBtn
            descriptionTitle
            descriptionSubtitle
            descriptionPlaceholder
            charactersLabel
            savingBtn
            updateBtn
            createBtn

            createSuccess
            createSuccessDescription
            createError
            updateSuccess
            updateSuccessDescription
            updateError
            logoRequired
            logoRequiredDescription
            defaultSchoolTitle

            validations {
              startDateFuture
              endDateValid
              descriptionRequired
              descriptionMaxLength
              schoolRequired
              logoRequired
              logoSize
              logoDimensions
              endDateAfterStart
              dateRangeLimit
            }
          }

          actions {
            unpublishBtn
            publishBtn
            editBtn
            duplicateBtn
            deleteBtn
          }

          deleteDialog {
            title
            description
            confirmBtn
            cancelBtn
          }

          preview {
            like
            liveLabel
            scheduledLabel
            liveFromLabel
            untilLabel
            totalLikesLabel

            publishSuccess
            publishSuccessDescription
            publishError
            publishErrorDescription
            unpublishSuccess
            unpublishSuccessDescription
            unpublishError
            unpublishErrorDescription
            deleteSuccess
            deleteSuccessDescription
            deleteError
            deleteErrorDescription
          }
        }
      }
    }
  }
`;

export const FETCH_MY_SCHOOLS = gql`
  query fetchMySchools($asRegularUser: Boolean) {
    fetchMySchools(asRegularUser: $asRegularUser) {
      id
      attributes {
        name
      }
    }
  }
`;

export const FETCH_WILDCARDS = gql`
  query ListWildCards {
    fetchWildcard {
      id
      attributes {
        title
        startDate
        endDate
        description
        status
        likes
        ctaText
        image {
          data {
            id
            attributes {
              url
            }
          }
        }
        internal
        schools {
          data {
            id
            attributes {
              name
            }
          }
        }
        cta {
          podcast {
            data {
              attributes {
                slug
              }
            }
          }
          mindfulExercise {
            data {
              attributes {
                slug
              }
            }
          }
          course {
            data {
              attributes {
                slug
              }
            }
          }
          resource {
            data {
              attributes {
                slug
              }
            }
          }
          redirectToCurrentInsight
          redirectToCurrentMindfulMinute
          redirectToCalendar
          redirectToEmotionWheel
        }
      }
    }
  }
`;

export const QUERY_FETCH_WILDCARDS = gql`
  query fetchWildcards($today: Date!) {
    wildcards(filters: { startDate: { lte: $today }, endDate: { gte: $today }, status: { eq: "PUBLISHED" } }) {
      data {
        id
        attributes {
          startDate
          endDate
          description
          likes
          title
          ctaText
          internal
          cta {
            podcast {
              data {
                attributes {
                  slug
                }
              }
            }
            mindfulExercise {
              data {
                attributes {
                  slug
                }
              }
            }
            course {
              data {
                attributes {
                  slug
                }
              }
            }
            resource {
              data {
                attributes {
                  slug
                }
              }
            }
            redirectToCurrentInsight
            redirectToCurrentMindfulMinute
            redirectToCalendar
            redirectToEmotionWheel
          }
          image {
            data {
              ...ImageFragment
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
